import React from "react";
import WarningLastSubjectNotSelectedDialog from "./WarningLastSubjectNotSelectedDialog";

const LoginWarningDialog = ({ warning, onConfirm }) => {
  if (!warning) {
    return null;
  }

  const handleOk = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  if (warning.type == "last_subject_not_selected") {
    return (
      <WarningLastSubjectNotSelectedDialog
        subject={warning.payload.subject}
        handleOk={handleOk}
      />
    );
  }

  return null;
};

export default LoginWarningDialog;
